export default __webpack_public_path__ + "static/media/skate_park.4ee15b5b.svg";